import React from "react";
import { SocialIcon } from "react-social-icons";
import teamData from "../data/teamData.json";
import "../styles/team.css";

// Import images
import ChandrasekharImage from "../assets/Chandrasekhar.jpg";

const imageMap = {
  "Chandrasekhar Turlapati": ChandrasekharImage,
};

const Team = () => {
  return (
    <section id="team" className="section">
      <h2 className="title">Our Team</h2>
      <div className="team-list">
        {teamData.map((member, index) => (
          <div key={index} className="team-item">
            <div className="team-image-wrapper">
              <img
                src={imageMap[member.name]}
                alt={member.name}
                className="team-image"
              />
            </div>
            <div className="team-details">
              <div className="team-header">
                <h3>{member.name}</h3>
                <SocialIcon
                  url={member.linkedin}
                  className="linkedin-icon"
                  target="_blank"
                  rel="noopener noreferrer"
                />
              </div>
              <p>{member.writeup}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Team;
